<template>
  <div class="flex flex-col gap-y-3 p-5 shadow-100">
    <h3 class="font-semibold typo-body">
      {{ title }}
    </h3>
    <div class="mt-auto flex gap-x-6">
      <SingleSelect
        v-model="selectedFile"
        title="select-file"
        :options="mappedDownloads"
        variant="gray"
        size="sm"
      />
      <AppButton
        :download="selectedFile.media_name ? selectedFile.media_name.replace(' ', '_') + '_' + selectedFile.title + '.pdf' : ''"
        class="size-9 shrink-0"
        :disabled="!selectedFile.url"
        :to="selectedFile.url"
      >
        <template #icon>
          <IconDownload class="size-6" />
        </template>
      </AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  download: DownloadProduct
}>()

const mappedDownloads = computed(() => {
  if (!Array.isArray(props.download?.files)) {
    return []
  }

  return props.download.files.reduce<DownloadFile[]>((acc, { languages, url, media_name }) => {
    languages?.forEach((lang: string) => {
      acc.push({
        title: lang,
        slug: lang,
        url,
        media_name,
      })
    })
    return acc
  }, [])
})

interface DownloadFile {
  title: string
  slug: string
  url: string
  media_name: string
}

const selectedFile = ref<DownloadFile>({
  title: '',
  slug: '',
  url: '',
  media_name: '',
})

const title = usePerfionCultureText(props.download.title)
</script>
